import _ from 'lodash';
import { useMemo } from 'react';
import { Controller, FieldValues, ControllerRenderProps, Control, FieldErrors } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import ErrorMesssage from 'v2/common/components/ErrorMessage/index';
import { useSelector } from 'react-redux';
import { getSelectorBasedStoreValue } from 'v2/modules/withRunForm/redux/selector';

type CaseIndexFieldType = {
  name: string,
  value: string | number,
  control: Control<FieldValues>,
  errors: FieldErrors<FieldValues>,
  onUpdatePipeConfig: (name: string, value: string) => void
};

const CaseIndexField: React.FC<CaseIndexFieldType> = ({
  name: propsName, value, errors, control, onUpdatePipeConfig
}) => {
  const uniqueId = useMemo(() => _.uniqueId(`pipe_${propsName}_`), [propsName]);
  const errorMessage = _.get(errors, `${uniqueId}.message`, '');
  const quantConfigCases = useSelector(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (state) => getSelectorBasedStoreValue(state, 'quantConfig.cases')
  );

  const rulesValidator = useMemo(() => {
    return {
      validate: () => {
        if (_.isEmpty(_.toString(value))) return 'Please select the valid case index value';
        return true;
      },
    };
  }, [value]);

  const caseIndexOptions = useMemo(() => _.map(
    quantConfigCases,
    (_, kaseIndex) => <option key={kaseIndex} value={kaseIndex}>{`Case ${Number(kaseIndex) + 1}`}</option>
  ), [quantConfigCases]);

  return (
    <ErrorMesssage message={errorMessage}>
      <Controller
        render={({
          onChange, ref, name
        }: ControllerRenderProps<FieldValues>) => (
          <Form.Control
            as="select"
            id={name}
            size="sm"
            name={uniqueId}
            ref={ref}
            value={value}
            onChange={(event) => {
              const targetValue = event.target.value;
              onUpdatePipeConfig(propsName, targetValue);
              onChange(targetValue);
            }}
          >
            {caseIndexOptions}
          </Form.Control>
        )}
        control={control}
        defaultValue={value}
        name={uniqueId}
        rules={rulesValidator}
      />
    </ErrorMesssage>
  );
};

export default CaseIndexField;
